import React, { useState } from 'react';
import { Search, ShoppingCart, Menu, X, ChevronRight, Check, Star, Clock, Shield, Smartphone } from 'lucide-react';

// Featured Products Component
const FeaturedProducts = () => {
  const products = [
    {
      name: 'iPhone 16',
      tagline: 'Power meets elegance',
      color: 'from-blue-50 to-blue-100'
    },
    {
      name: 'MacBook Air M3',
      tagline: 'Lightweight. Limitless.',
      color: 'from-gray-50 to-gray-100'
    },
    {
      name: 'Apple Watch Series 10',
      tagline: 'Fitness meets style',
      color: 'from-pink-50 to-pink-100'
    },
    {
      name: 'AirPods Pro 2',
      tagline: 'Pure sound, zero noise',
      color: 'from-purple-50 to-purple-100'
    }
  ];

  return (
    <section className="py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h3 className="text-sm uppercase tracking-widest text-gray-500 mb-2">Top Picks</h3>
          <h2 className="text-4xl lg:text-5xl font-semibold tracking-tight mb-4">
            This Season
          </h2>
          <p className="text-gray-600 text-lg">
            Explore the most loved tech — from the newest iPhones to high-performance accessories.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {products.map((product, index) => (
            <div 
              key={index}
              className={`bg-gradient-to-br ${product.color} rounded-3xl p-8 lg:p-12 hover:scale-[1.02] transition-transform duration-300 cursor-pointer group`}
            >
              <div className="h-64 flex items-center justify-center mb-6">
                <div className="w-48 h-48 bg-white/50 rounded-full flex items-center justify-center">
                  <Smartphone className="w-24 h-24 text-gray-400" />
                </div>
              </div>
              <h3 className="text-2xl font-semibold mb-2">{product.name}</h3>
              <p className="text-gray-600 mb-4">{product.tagline}</p>
              <button className="flex items-center text-blue-600 font-medium group-hover:gap-2 transition-all">
                View Product <ChevronRight className="w-4 h-4 ml-1" />
              </button>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button className="text-blue-600 font-medium hover:underline">
            View all Products →
          </button>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts